import { gql } from "@apollo/client";

export const FETCH_SCHEDULED_EXPORTS = gql`
  query FetchScheduledExports($page: Int) {
    me {
      scheduledExports(page: $page) {
        data {
          id
          target
          exportFileName
          scheduleName
          scheduleFrequency
          exportMethod
          createdAt
          updatedAt
          recipients
          schedules {
            localDay
            localTime
            timeZone
          }
        }
        totalPages
      }
      dataExportEmailRecipients
    }
  }
`;

export const FETCH_SCHEDULED_EXPORT_DETAILS = gql`
  query FetchScheduledExportDetails($id: String!) {
    me {
      scheduledExportDetails(id: $id) {
        id
        clientId
        userId
        formats
        target
        level
        exportType
        exportAggregation
        removeZeroSpend
        aggregateData
        includeIds
        includeKindAndPlatform
        timeGranularity
        timeFrameType
        timeFrameStartDate
        timeFrameEndDate
        scheduleName
        exportMethod
        exportMethodDetails
        exportFileName
        frequency
        schedules {
          localDay
          localTime
          timeZone
        }
        recipients
        breakdowns {
          position
          key
          values
        }
        metrics {
          id
          label
          position
          attributionModels
          attributionWindows
          accountingModes
        }
        defaultAttributionModels
        defaultAttributionWindows
        defaultAccountingModes
      }
    }
  }
`;

export const FETCH_DATA_EXPORT_EMAIL_RECIPIENTS = gql`
  query FetchDataExportEmailRecipients {
    me {
      dataExportEmailRecipients
    }
  }
`;

export const UPDATE_SCHEDULED_EXPORT_RECIPIENTS = gql`
  mutation UpdateScheduledExportRecipients(
    $id: String!
    $recipients: [String!]!
  ) {
    updateScheduledExportRecipients(id: $id, recipients: $recipients) {
      id
      scheduleName
      scheduleFrequency
      exportMethod
      createdAt
      updatedAt
      recipients
      schedules {
        localDay
        localTime
        timeZone
      }
    }
  }
`;

export const DELETE_SCHEDULED_EXPORT = gql`
  mutation DeleteScheduledExport($id: String!) {
    deleteScheduledExport(id: $id)
  }
`;

export const RUN_TEST_SCHEDULED_EXPORT = gql`
  mutation RunTestScheduledExport($id: String!) {
    runTestScheduledExport(id: $id)
  }
`;

export const UPDATE_SCHEDULED_EXPORT = gql`
  mutation UpdateScheduledExport(
    $id: String!
    $data: DataExportPerformanceMetricsConfigInput!
  ) {
    updateScheduledExport(id: $id, data: $data)
  }
`;

export const CREATE_DATA_EXPORT_PERFORMANCE_METRICS_CONFIG = gql`
  mutation CreateDataExportPerformanceMetricsConfig(
    $data: DataExportPerformanceMetricsConfigInput!
  ) {
    createDataExportPerformanceMetricsConfig(data: $data) {
      id
    }
  }
`;

export const VALIDATE_EXTERNAL_BUCKET_ACCESS = gql`
  mutation ValidateExternalBucketAccess($bucketName: String!) {
    validateExternalBucketAccess(bucketName: $bucketName) {
      status
      message
    }
  }
`;

export const VALIDATE_SCHEDULE_NAME = gql`
  mutation ValidateScheduleName($scheduleName: String!) {
    validateScheduleName(scheduleName: $scheduleName) {
      status
    }
  }
`;
